import * as React from 'react'

const SvgMisuseAltIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.381 14.375L10 10.995l-3.381 3.38-.994-.994L9.005 10l-3.38-3.38.994-.995L10 9.005l3.38-3.38.995.994L10.995 10l3.38 3.381-.994.994zM10 2.5A7.5 7.5 0 112.5 10 7.509 7.509 0 0110 2.5zm0-1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgMisuseAltIcon
